import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

const RoomImageSlider = ({ imageJson }) => {
  const images = JSON.parse(imageJson);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    draggable: true,
    swipe: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div style={{ width: '100vw', margin: '0', padding: '0' }}>
      <Slider {...settings}>
        {images
          .filter((img) => img.IsActive)
          .map((img, index) => (
            <div key={index} style={{ padding: '0 4px' }}>
              <img
                src={`https://admin.abhyaranyan.com/RoomsUploadimage/${img.path}`}
                alt={`Room ${index}`}
                style={{
                  width: '100%',
                  height: '140px',       // Adjust height as needed
                  objectFit: 'cover',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                }}
              />
            </div>
          ))}
      </Slider>
    </div>
  );
};

export default RoomImageSlider;
